/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Intake_TitleInputs */



/**
* | output |
* | --- |
* | "There’s no agenda for this conversation yet" |
*
* @param {Meeting_Prep_Intake_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_intake_title = /** @type {((inputs?: Meeting_Prep_Intake_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Intake_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er is nog geen agenda voor dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n’y a pas encore d’ordre du jour pour cette conversation")
	return /** @type {LocalizedString} */ ("There’s no agenda for this conversation yet")
});